'use client'

import ShareButton from '@/app/(pages)/profile/(with-container)/(sidebar-layout)/refer/ShareButton';
import SmartBackButton from '@/components/SmartBackButton';
import { useHotelDetailAction } from '@/core/stores/hoteldetailActions';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { deslugify } from '@/utils/slugify';
import { faChevronLeft, faShareNodes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePathname } from 'next/navigation';
import Favorite from './Favourite';
import NavigateButton from '@/app/(pages)/(activites)/activities/[country]/[city]/[activityId]/(detailPage)/NewComponents/HotelRedirectButton';

export default function DetailsHeader({ hotelName, hotelId, city, hotelCode, country }: { country: string; hotelCode: string, hotelName: string, hotelId: string, city: string }) {


    const pathname = usePathname()

    const { getSearchParamsString } = useSetSearchParams()

    const { setShowCalendar } = useHotelDetailAction()

    return (
        <div
            className='sticky top-0 left-0 z-[200] bg-[#f9fafb] w-full shadow'>
            <div className='px-4 py-3 flex items-center justify-between'>
                <div className='grid grid-cols-[24px,_1fr] gap-3'>
                    <SmartBackButton
                        customUrl={`/hotel/${country}/${city}/${hotelName}?${getSearchParamsString()}`}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} className='justify-self-center place-self-center text-neutral-800' />
                    </SmartBackButton>
                    <button onClick={() => setShowCalendar(true)}>
                        <span className='text-sm text-neutral-800 font-semibold line-clamp-1 text-start'>{deslugify(hotelName)}</span>
                    </button>
                </div>
                <div className='flex items-center text-neutral-600 gap-3'>
                    <Favorite hotelId={hotelCode} />
                    <ShareButton content={pathname}>
                        <FontAwesomeIcon icon={faShareNodes} />
                    </ShareButton>
                </div>
            </div>
            <div className='flex max-w-full gap-4 px-3 items-end justify-around border-b overflow-x-auto no-scroller mt-2'>
                <NavigateButton
                    actionMessage={'opened more facilities'}
                    to={`/hotel/${country}/${city}/${hotelName}/facilities?${getSearchParamsString()}`}
                    className={`${pathname === `/hotel/${country}/${city}/${hotelName}/facilities` ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b px-1`}>
                    Facilities
                </NavigateButton>
                <NavigateButton
                    actionMessage={'opened more Contact'}
                    to={`/hotel/${country}/${city}/${hotelName}/contact?${getSearchParamsString()}`}
                    className={`${pathname === `/hotel/${country}/${city}/${hotelName}/contact` ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b px-1`}>
                    Contact
                </NavigateButton>
                <NavigateButton
                    actionMessage={'opened more rooms'}
                    to={`/hotel/${country}/${city}/${hotelName}/rooms?${getSearchParamsString()}`}
                    className={`${pathname === `/hotel/${country}/${city}/${hotelName}/rooms` ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b px-1`}>
                    Rooms
                </NavigateButton>
                <NavigateButton
                    actionMessage={'opened more description'}
                    to={`/hotel/${country}/${city}/${hotelName}/description?${getSearchParamsString()}`}
                    className={`${pathname === `/hotel/${country}/${city}/${hotelName}/description` ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b px-1`}>
                    Description
                </NavigateButton>

                <NavigateButton
                    actionMessage={'opened  location'}
                    to={`/hotel/${country}/${city}/${hotelName}/location?${getSearchParamsString()}`}
                    className={`${pathname === `/hotel/${country}/${city}/${hotelName}/location` ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b px-1`}>
                    Location
                </NavigateButton>
                {/* <NavigateButton
                    actionMessage={'opened  reviews'}
                    to={`/hotel/${country}/${city}/${hotelName}/review?${getSearchParamsString()}`}
                    className={`${pathname === `/hotel/${country}/${city}/${hotelName}/review` ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b px-1`}>
                    Reviews
                </NavigateButton> */}
                <NavigateButton
                    actionMessage={'opened  policies'}
                    to={`/hotel/${country}/${city}/${hotelName}/policies?${getSearchParamsString()}`}
                    className={`${pathname === `/hotel/${country}/${city}/${hotelName}/policies` ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b px-1`}>
                    Policies
                </NavigateButton>
            </div>
        </div>
    );
}